var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 881,
    height: 880,
    viewBox: "0 0 881 880",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 880C683.505 880 880.5 683.005 880.5 440C880.5 196.995 683.505 0 440.5 0C197.495 0 0.5 196.995 0.5 440C0.5 683.005 197.495 880 440.5 880Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M594.9 462C594.9 455.1 589.3 449.5 582.4 449.5C575.5 449.5 569.9 455.1 569.9 462C567.5 531.3 510.4 587 440.5 587C370.6 587 313.5 531.3 311.1 462C311.1 455.1 305.5 449.5 298.6 449.5C291.7 449.5 286.1 455.1 286.1 462C288.4 540.9 350.1 605.2 428 611.5V667.9V668C428 674.9 433.6 680.5 440.5 680.5C447.4 680.5 453 674.9 453 668V667.9V611.5C530.9 605.2 592.7 540.9 594.9 462Z",
    fill: "#333D6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440.5 542C487.2 542 525 504.2 525 457.5V313C525 266.3 487.2 228.5 440.5 228.5C393.8 228.5 356 266.3 356 313V457.5C356 504.2 393.8 542 440.5 542Z",
    fill: "#333D6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.ef2554c7582e692c3873c39a5ae5dbe4.svg";
export { ForwardRef as ReactComponent };